import { useState } from 'react'

import { VisibilityTwoTone } from '@mui/icons-material'
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Tooltip,
  Typography,
} from '@mui/material'
import {
  Button,
  Datagrid,
  FunctionField,
  List,
  RaRecord,
  ReferenceField,
  TextField,
  useTranslate,
} from 'react-admin'
import { API } from '../../helpers/Api.helper'
import { DateHelper, LONG_FORMAT } from '../../helpers/Date.helper'
import { NumberFormatter } from '../../helpers/NumberFormatter.helper'
import { Prepayment } from '../../types/Prepayments'

type PrepaymentDetailsProps = {
  prepaymentId: Prepayment['id']
  prepaymentLabel: Prepayment['label']
}

export const PrepaymentDetails = ({ prepaymentId, prepaymentLabel }: PrepaymentDetailsProps) => {
  const translate = useTranslate()
  const [isModalOpen, setIsModalOpen] = useState(false)

  return (
    <>
      <Tooltip title={translate('_generics.display')} placement="top" arrow>
        <span>
          <Button
            size="small"
            color="primary"
            onClick={() => setIsModalOpen(true)}
            style={{
              minWidth: 'fit-content',
            }}
          >
            <VisibilityTwoTone
              color="primary"
              fontSize="small"
              style={{
                marginLeft: '0.5rem',
              }}
            />
          </Button>
        </span>
      </Tooltip>
      <Dialog
        aria-labelledby="prepayments-details"
        open={isModalOpen}
        maxWidth="md"
        fullWidth
        onClose={() => setIsModalOpen(false)}
      >
        <DialogTitle id="prepayments-details">
          {translate('pages.prepayments.prepaymentDetails')}&nbsp;•&nbsp;{prepaymentLabel}
        </DialogTitle>
        <DialogContent dividers>
          <Typography fontWeight="bold" mb="1rem">
            {translate('pages.prepayments.listOfConsumedInStatements')} :{' '}
          </Typography>
          <List
            resource="statementPrepaymentRows"
            filter={{ prepaymentId }}
            exporter={false}
            perPage={API.DEFAULT_PAGINATION.perPage}
            actions={false}
          >
            <Datagrid bulkActionButtons={false} rowClick={false} hover={false}>
              <FunctionField
                source="amountInEuros"
                label={translate('pages.prepayments.amountInEuros')}
                render={(record: RaRecord | undefined) => (
                  <span>{NumberFormatter.formatEuros(record?.amountInEuros)}</span>
                )}
              />
              <ReferenceField
                source="statementId"
                reference="statements"
                label={translate('pages.statements._title')}
                link="show"
              >
                <TextField source="month" /> / <TextField source="year" />
              </ReferenceField>
              <FunctionField
                source="recognitionPeriod"
                label={translate('_generics.period')}
                render={(record: RaRecord | undefined) => (
                  <span>{DateHelper.format(record?.recognitionPeriod, 'MMM YYYY')}</span>
                )}
              />
              <FunctionField
                source="createdAt"
                label={translate('_generics.createdAt')}
                render={(record: RaRecord | undefined) => (
                  <span>{DateHelper.format(record?.createdAt, LONG_FORMAT)}</span>
                )}
              />
              <FunctionField
                source="updatedAt"
                label={translate('_generics.updatedAt')}
                render={(record: RaRecord | undefined) => (
                  <span>{DateHelper.format(record?.updatedAt, LONG_FORMAT)}</span>
                )}
              />
            </Datagrid>
          </List>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setIsModalOpen(false)
            }}
            label={translate('_generics.close')}
          />
        </DialogActions>
      </Dialog>
    </>
  )
}
